/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Physio_BodyInputs */

const en_for_whom_physio_body = /** @type {(inputs: For_Whom_Physio_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming back from an injury step by step, with exercises to do at home between visits.`)
};

const pl_for_whom_physio_body = /** @type {(inputs: For_Whom_Physio_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót po kontuzji krok po kroku i ćwiczenia do domu między wizytami.`)
};

/**
* | output |
* | --- |
* | "Coming back from an injury step by step, with exercises to do at home between visits." |
*
* @param {For_Whom_Physio_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_physio_body = /** @type {((inputs?: For_Whom_Physio_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Physio_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_physio_body(inputs)
	return en_for_whom_physio_body(inputs)
});